"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.solanaGetAddress = solanaGetAddress;
exports.solanaSignTx = solanaSignTx;
const core = __importStar(require("@shapeshiftoss/hdwallet-core"));
const web3_js_1 = require("@solana/web3.js");
const bs58 = __importStar(require("bs58"));
const utils_1 = require("./utils");
// ledger expects m/ prefix to be stripped
// https://www.npmjs.com/package/@ledgerhq/hw-app-solana#getaddress
function addressNListToBIP32Path(addressNList) {
    return core.solanaAddressNListToBIP32(addressNList).slice(2);
}
function solanaGetAddress(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const bip32Path = addressNListToBIP32Path(msg.addressNList);
        const res = yield transport.call("Solana", "getAddress", bip32Path, !!msg.showDisplay);
        (0, utils_1.handleError)(res, transport, "Unable to obtain address from device.");
        // solana address format is a base58 encoded string
        // https://github.com/LedgerHQ/ledger-live/blob/develop/libs/coin-modules/coin-solana/src/hw-getAddress.ts#L12
        return bs58.encode(res.payload.address);
    });
}
function solanaSignTx(transport, msg) {
    return __awaiter(this, void 0, void 0, function* () {
        const address = yield solanaGetAddress(transport, msg);
        const bip32Path = addressNListToBIP32Path(msg.addressNList);
        const transaction = core.solanaBuildTransaction(msg, address);
        const txBuffer = Buffer.from(transaction.message.serialize());
        const res = yield transport.call("Solana", "signTransaction", bip32Path, txBuffer);
        (0, utils_1.handleError)(res, transport, "Unable to sign Solana transaction");
        transaction.addSignature(new web3_js_1.PublicKey(address), res.payload.signature);
        return {
            serialized: Buffer.from(transaction.serialize()).toString("base64"),
            signatures: transaction.signatures.map((signature) => Buffer.from(signature).toString("base64")),
        };
    });
}
//# sourceMappingURL=solana.js.map